import React, { Component } from "react";
import { Space } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import { DownloadOutlined } from "@ant-design/icons";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { ModalItem, ButtonItem, MensajeError } from "../../../../../Components/Items";
import moment from "moment";
import reporteDiaProduccionPdf from "../../../../../Pdf/reporteDiaProduccionPdf";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

class ModalPdfPlaneacionPU extends Component {
  iframeRef = React.createRef();
  state = { loading: false, pdf: null };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) this.consultar();
      else this.setState({ pdf: null });
    }
  }

  consultar() {
    const { flujoId, presupuestoPUId, desde, hasta, etiquetaRango, soloPlaneadas } = this.props;
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/datosPdfPlaneacion",
        { empresaId: this.props.empresaId, flujoId, presupuestoPUId, desde, hasta, soloPlaneadas },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) {
          MensajeError({ message: res.data.error || "No se pudo generar el reporte" });
          this.setState({ loading: false });
          return;
        }
        const pdf = pdfMake.createPdf(
          reporteDiaProduccionPdf({
            grupos: [res.data.presupuesto],
            empresa: res.data.empresa,
            etiquetaRango,
            ahora: res.data.ahora,
            usuarioNombre: this.props.usuarioNombre,
            titulo: `REPORTE DE PRODUCCIÓN — ${(this.props.flujoNombre || "").toUpperCase()}`,
          })
        );
        this.setState({ loading: false, pdf }, () => this.abrirEnIframe(pdf));
      })
      .catch(() => {
        MensajeError({ message: "Hubo un error y no se pudo generar el reporte" });
        this.setState({ loading: false });
      });
  }

  abrirEnIframe(pdf, intento = 0) {
    const frame = this.iframeRef.current?.contentWindow || window.frames["PlaneacionProduccionPdfIframe"];
    if (frame) {
      pdf.open({}, frame);
      return;
    }
    if (intento < 10) setTimeout(() => this.abrirEnIframe(pdf, intento + 1), 100);
  }

  descargar() {
    if (this.state.pdf) {
      const nombre = `${moment().format("DD MM YYYY")} Reporte_${(this.props.flujoNombre || "flujo").replace(/\s+/g, "_")}_${(this.props.etiquetaRango || "").replace(/\s+/g, "_")}.pdf`;
      this.state.pdf.download(nombre);
    }
  }

  render() {
    return (
      <ModalItem
        title={`Reporte de producción — ${this.props.flujoNombre || ""}`}
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.props.onCerrar}
        paddingTop
        width={1000}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 10 }}>
          <Space>
            <ButtonItem icon={<DownloadOutlined />} type="primary" disabled={!this.state.pdf} onClick={() => this.descargar()}>
              Descargar PDF
            </ButtonItem>
            <ButtonItem rojo onClick={this.props.onCerrar}>
              Cerrar
            </ButtonItem>
          </Space>
        </div>
        <iframe
          ref={this.iframeRef}
          title="Planeación Producción PDF"
          style={{ width: "100%", height: "75vh", border: "1px solid #d9d9d9" }}
          id="PlaneacionProduccionPdfIframe"
          name="PlaneacionProduccionPdfIframe"
        />
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  unidadTiempoProduccion: state.empresa.unidadTiempoProduccion,
  usuarioNombre: [state.user.nombre, state.user.apellidoPaterno, state.user.apellidoMaterno].filter(Boolean).join(" "),
});

export default connect(mapStateToProps)(ModalPdfPlaneacionPU);
